import { useState, useEffect, Fragment } from "react";
import TextField from "@material-ui/core/TextField";
import useStyles from "./styles";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory, withRouter } from "react-router-dom";
import { useAuth } from "oidc-react";

const ForgotPassword = ({ returnUrl, ...props }: any) => {
  const [email, setEmail] = useState("");
  const history = useHistory();

  var auth = useAuth();
  auth?.userManager?.clearStaleState();

  useEffect(() => {
    auth?.userManager?.clearStaleState();
  }, [auth]);
  var classes = useStyles();

  const recover = async (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    const response = await fetch(
      `/api/authenticate/forgotpassword/?ReturnUrl=${returnUrl}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(email),
      }
    );

    const data = await response.json();

      if (data) {
        window.location.href = `/login/forgot/email?email=${email}`;
    }
  };

  return (
    <Fragment>
      <Avatar className={classes.avatar}>
        <VpnKeyOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        ¿Olvidaste tu Contraseña?
      </Typography>
      <form className={classes.form}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Email"
          name="email"
          autoComplete="email"
          type="email"
          autoFocus
          placeholder="Favor ingresa tu email"
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          type="button"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={(e: any) => recover(e)}
        >
          Cambiar
        </Button>
      </form>
    </Fragment>
  );
};

export default withRouter(ForgotPassword);
